import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 28,
	viewBox: "0 0 30 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18 8.06421V5.06421C18 4.26856 17.6839 3.5055 17.1213 2.94289C16.5587 2.38028 15.7956 2.06421 15 2.06421H4.5C3.70435 2.06421 2.94129 2.38028 2.37868 2.94289C1.81607 3.5055 1.5 4.26856 1.5 5.06421V23.0642C1.5 23.8599 1.81607 24.6229 2.37868 25.1855C2.94129 25.7481 3.70435 26.0642 4.5 26.0642H15C15.7956 26.0642 16.5587 25.7481 17.1213 25.1855C17.6839 24.6229 18 23.8599 18 23.0642V20.0642",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.5 14.0642H28.5M28.5 14.0642L24 9.56421M28.5 14.0642L24 18.5642",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLogout;
